import React from "react";
import { connect } from "react-redux";
import { CorperateDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { ROUTE_PATH } from "utils/constants/routePath";
import momentTZ from "moment-timezone";
import { RENDER_STATUS_PRODUCT_WARRANTY_SET } from "utils/functions/productWarrantySet";
import { MdAdd } from "react-icons/md";
import { Buttons, Displays, Forms, Tables } from "components";
import { CorperateInfoWidget } from "widgets";

class CorperateDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    if (this.props.router.params.id !== "create") {
      this.fetchData();
    } else {
      this.setState({
        isLoading: false,
      });
    }
  }

  fetchData = async () => {
    const { id } = this.props.router.params;
    let [res, resSet] = await Promise.all([
      portalService.GET_ORGANIZATION_DETAIL(id),
      portalService.GET_CORPERATE_PRODUCT_SET_LIST(
        `?organization_ref_id=${id}&pagination=false`
      ),
    ]);
    if (res && res.status === 200) {
      this.setState({
        initialValues: { ...res.data },
        productSetData:
          resSet && resSet.status === 200 ? resSet.data.docs : [],
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  handleClickBack = (e) => {
    this.props.router.navigate(-1);
  };

  handleClickProductSet = (setId) => {
    this.props.router.navigate(
      `${ROUTE_PATH.CORPERATE_LIST}/${this.props.router.params.id}/set/${setId}`
    );
  };

  handleSubmit = async (values) => {
    const { deleteTemp } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let params = {
      ...values,
      province: values.province.name_th,
      province_en: values.province.name_en,
      province_code: values.province.value,
    };
    if (values.member_list && values.member_list.length > 0) {
      params.member_list = values.member_list.map((e) => {
        return !e.member.isNew
          ? {
              name: e.member.name,
              member_ref_id: e.member.member_ref_id,
              isNew: e.member.isNew,
            }
          : {
              name: `${e.member.first_name} ${e.member.last_name}`,
              member_ref_id: e.member._id,
              isNew: e.member.isNew,
            };
      });
    }
    if (deleteTemp && deleteTemp.length > 0) {
      if (!params.member_list || params.member_list.length === 0) {
        params.member_list = deleteTemp.map((e) => ({
          name: e.member.name,
          member_ref_id: e.member.member_ref_id,
          isDelete: e.isDelete,
        }));
      } else {
        deleteTemp.forEach((e) => {
          params.member_list.push({
            name: e.member.name,
            member_ref_id: e.member.member_ref_id,
            isDelete: e.isDelete,
          });
        });
      }
    }
    // หน้านี้ใช้สร้างใหม่เท่านั้น การแก้ไขทำผ่าน popup ใน CorperateInfoWidget
    let res = await portalService.POST_ORGANIZATION_DETAIL(params);
    if (res && res.status === 200) {
      toast.success("อัพเดตสำเร็จ");
      this.props.router.navigate(ROUTE_PATH.CORPERATE_LIST);
    } else {
      this.setState({
        isBgLoading: false,
      });
      toast.error("อัพเดตไม่สำเร็จ");
    }
  };

  handleDeleteItem = (e) => {
    const { deleteTemp } = this.state;
    if (!e.member.isNew) {
      if (!deleteTemp) {
        this.setState({
          deleteTemp: [{ ...e, isDelete: true }],
        });
      } else {
        let temp = deleteTemp;
        temp.push({ ...e, isDelete: true });
        this.setState({
          deleteTemp: [...temp],
        });
      }
    }
  };

  render() {
    const { authenRedux, router } = this.props;
    const { isLoading, isBgLoading, initialValues, productSetData } =
      this.state;
    const isCreate = router.params.id === "create";
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "corperate");
    return (
      <CorperateDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          isCreate ? (
            <div className="block_section">
              <div className="title">Corperate / New Corperate</div>
              <Forms.CorperateForm
                permission={permission}
                onCancel={this.handleClickBack}
                onDeleteItem={this.handleDeleteItem}
                onSubmit={this.handleSubmit}
              />
            </div>
          ) : (
            <>
              <div className="block_section">
                <CorperateInfoWidget
                  title="Corperate / Corperate Detail"
                  data={initialValues}
                  permission={permission}
                  onBack={this.handleClickBack}
                  onUpdateSuccess={this.fetchData}
                  onDeleteSuccess={() =>
                    router.navigate(ROUTE_PATH.CORPERATE_LIST)
                  }
                />
              </div>
              <div className="block_section product_set_section">
                <div className="section_header">
                  <div className="title">Product Set</div>
                  {permission && permission.is_create && (
                    <div className="w150">
                      <Buttons.BgIconPrefix
                        label="Create Set"
                        icon={<MdAdd size={18} />}
                        onClick={() => this.handleClickProductSet("create")}
                      />
                    </div>
                  )}
                </div>
                <Tables.Standard
                  columns={productSetColumns({
                    handleClickProductSet: this.handleClickProductSet,
                  })}
                  data={productSetData}
                />
              </div>
            </>
          )
        )}
      </CorperateDetailContainerStyled>
    );
  }
}

const productSetColumns = ({ handleClickProductSet }) => {
  const renderCell = (props, children) => (
    <div
      className="row_click"
      onClick={() => handleClickProductSet(props.row.original._id)}
    >
      {children}
    </div>
  );
  return [
    {
      Header: <div style={{ textAlign: "left" }}>Create Date</div>,
      accessor: "created_at",
      Cell: (props) =>
        renderCell(
          props,
          momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")
        ),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Setname</div>,
      accessor: "name",
      Cell: (props) => renderCell(props, props.value),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Setcode</div>,
      accessor: "code",
      Cell: (props) => renderCell(props, props.value),
    },
    {
      Header: <div style={{ textAlign: "center" }}>Status</div>,
      accessor: "status",
      Cell: (props) => {
        const renderStatus = RENDER_STATUS_PRODUCT_WARRANTY_SET(props.value);
        return renderCell(
          props,
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Displays.StatusLabel
              bg={renderStatus?.bg}
              label={renderStatus?.label}
            />
          </div>
        );
      },
    },
  ];
};

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CorperateDetailContainer));
